import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ShareGettingToRegattaBeach from "@/pages/ShareGettingToRegattaBeach";

export const Route = createFileRoute("/en/share/getting-to-regatta-beach")({
  head: () => buildRouteHead("/en/share/getting-to-regatta-beach"),
  component: ShareGettingToRegattaBeach,
});

